<script setup>
import Asterix2 from '@/assets/img/ico/asterix-2.svg'

defineProps({
  hero: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<template>
  <div class="infanzia-servizio-hero row-130-25 max">
    <div class="section-hero p-top-xxxl-1">
      <!-- eslint-disable vue/no-v-html -->
      <div class="section-left p-top-l-1">
        <div class="text-section">
          <div
            v-if="hero.titolo"
            class="title-base title"
            v-html="hero.titolo"
          />
          <div v-if="hero.testo" class="text-s-1-b text" v-html="hero.testo" />
        </div>
      </div>
      <div v-if="hero.cards.length" class="section-right p-top-l-1">
        <div
          v-for="card in hero.cards"
          :key="card.id"
          class="card"
          :style="{ backgroundColor: card.coloreCard.hex }"
        >
          <div class="card-svg">
            <Asterix2 :filled="true" />
          </div>
          <div
            v-if="card.titolo"
            class="card-title title-base2"
            v-html="card.titolo"
          />
          <div
            v-if="card.testo"
            class="card-text text-s-1-b"
            v-html="card.testo"
          />
          <div v-for="cta in card.cta" :key="cta.id">
            <DefaultBtn
              v-if="cta"
              :text="cta.testo"
              :content="cta.link ? cta.link : cta.file?.url || ''"
              :data-evento="cta.evento"
              class="button-round-1 with-icon"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfanziaServizioHero',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
